import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const MOTION_DESKTOP = '(min-width: 1024px) and (prefers-reduced-motion: no-preference)';
export const MOTION_ANY = '(prefers-reduced-motion: no-preference)';

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
};

export const scrollToIdWhenReady = (id, ms = 2500) => {
  const t0 = performance.now();
  let ok = 0;
  const tick = () => {
    const el = document.getElementById(id);
    if (el && Math.abs(el.getBoundingClientRect().top) > 4) { ok = 0; el.scrollIntoView({ behavior: 'instant' }); } else if (el) ok++;
    if (ok < 2 && performance.now() - t0 < ms) setTimeout(tick, 150);
  };
  setTimeout(tick, 150);
};

export { gsap, ScrollTrigger };
